export default __webpack_public_path__ + "static/media/t-shirt.d66334a1.jpg";